export enum ProgressType {
    BAR = 'BAR',
    CIRCLE = 'CIRCLE'
}
